//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { createNamespacedHelpers } from 'vuex';

import { AuthProviders, Apps } from 'utils/constants';
import {
	EMAIL,
	PASSWORD,
	RESET,
	VISIBLE_FIELDS,
	INTEGRATION_TO_CONNECT
} from '../store/modules/login/mutationTypes';
import OutfunnelLogoColors from '../images/outfunnel-logo-colors.svg';
import HubspotLogo from '../images/hubspot-logo.svg';
import PipedriveLogo from '../images/pipedrive-logo.svg';
import GoogleLogo from '../images/google-logo.svg';

import {
	LOGIN_USER_WITH_CREDENTIALS,
	START_OAUTH
} from '../store/modules/login/actionTypes';

const { mapState, mapActions, mapMutations } = createNamespacedHelpers('login');

export default {
	components: {
		OutfunnelLogoColors,
		HubspotLogo,
		PipedriveLogo,
		GoogleLogo
	},

	data: () => ({}),

	computed: {
		...mapState([
			'emailField',
			'passwordField',
			'generalErrors',
			'fieldErrors'
		]),

		registerLink() {
			return {
				name: 'register',
				query: this.$route.query
			};
		}
	},

	mounted() {
		this.RESET();

		const { connect } = this.$route.query;

		if (connect === Apps.KLAVIYO) {
			this.INTEGRATION_TO_CONNECT(Apps.KLAVIYO);
		}

		this.VISIBLE_FIELDS(['email', 'password']);
	},

	methods: {
		...mapMutations([
			EMAIL,
			PASSWORD,
			VISIBLE_FIELDS,
			RESET,
			INTEGRATION_TO_CONNECT
		]),

		...mapActions([
			LOGIN_USER_WITH_CREDENTIALS,
			START_OAUTH
		]),

		onInputKeypress(event) {
			if (event.key === 'Enter') {
				this.LOGIN_USER_WITH_CREDENTIALS();
			}
		},

		onStartPipedriveOauth() {
			this.START_OAUTH({ provider: AuthProviders.PIPEDRIVE });
		},

		onStartHubspotOauth() {
			this.START_OAUTH({ provider: AuthProviders.HUBSPOT });
		},

		onStartGoogleOauth() {
			this.START_OAUTH({ provider: AuthProviders.GOOGLE });
		}
	}
};
